import { useNavigate } from 'react-router-dom';
import { Container, Paper, Stack, Typography, Button } from '@mui/material';

/** Replaces the bare `<h1>404 - Not Found</h1>` the router used to render. */
const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper sx={{ p: 4 }}>
        <Stack spacing={2} alignItems="flex-start">
          <Typography variant="overline" color="text.secondary">Error 404</Typography>
          <Typography variant="h1">We can&apos;t find that page</Typography>
          <Typography variant="body2" color="text.secondary">
            The link may be out of date, or the record may have been removed.
          </Typography>
          <Stack direction="row" spacing={1} sx={{ pt: 1 }}>
            <Button variant="contained" onClick={() => navigate('/dashboard')}>Go to dashboard</Button>
            <Button onClick={() => navigate(-1)}>Back</Button>
          </Stack>
        </Stack>
      </Paper>
    </Container>
  );
};

export default NotFound;
